<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 100 100"
       preserveAspectRatio="xMidYMid"
       :style="style"
  >
    <path stroke="none"
          d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
          fill="#1d0e0b"
          transform="rotate(162 50 51)"
    >
      <animateTransform attributeName="transform"
                        type="rotate"
                        calcMode="linear"
                        values="0 50 51;360 50 51"
                        keyTimes="0;1"
                        dur="1s"
                        begin="0s"
                        repeatCount="indefinite"></animateTransform>
    </path>
  </svg>
</template>

<script>
export default {
  name: 'SvgLoading',
  props: ['size'],
  computed: {
    style() {
      let size = Number(this.size);
      if (isNaN(size) || size <= 0) {
        size = 200;
      }
      return `
        width: ${size}px;
        height: ${size}px;
      `;
    },
  },
};
</script>

<style scoped>
svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/assets/SvgLoading.vue